<template>
  <div class="columns is-multiline is-marginless is-mobile">
    <div class="column is-12 is-paddingless mb-20"
      v-if="data.adresseCommerciale">
      <div class="media">
        <b-icon
          icon="map-marker"
          size="is-medium"
          class="media-left"
          type="is-grid-5">
        </b-icon>
        <div class="media-content is-size-10px has-text-default">
          <label class="has-text-default">
            Adresse
          </label>
          <p class="is-size-14px has-text-weight-bold has-text-grid-1 mt-4">
            {{data.adresseCommerciale}}
          </p>
        </div>
      </div>
    </div>
    <div
      v-if="data.format"
      class="column is-paddingless is-6 mb-20">
      <div class="media">
        <b-icon
          icon="vector-intersection"
          size="is-medium"
          class="media-left"
          type="is-grid-5">
        </b-icon>
        <div class="media-content is-size-10px has-text-default">
          <label class="has-text-default">
            Format
          </label>
          <p class="is-size-14px has-text-grid-1 mt-4 has-text-weight-bold">
              {{data.format}}
          </p>
        </div>
      </div>
    </div>
    <div
      v-if="data.materiel"
      class="column is-paddingless is-6 mb-20">
      <div class="media">
        <b-icon
          icon="package-variant-closed"
          size="is-medium"
          class="media-left"
          type="is-grid-5">
        </b-icon>
        <div class="media-content is-size-10px has-text-default">
          <label class="has-text-default">
            Matériel
          </label>
          <p class="is-size-14px has-text-grid-1 mt-4 has-text-weight-bold">
              {{data.materiel}}
          </p>
        </div>
      </div>
    </div>
    <div
      v-if="data.categorie.libelle"
      class="column is-paddingless is-6 mb-20">
      <div class="media">
        <b-icon
          icon="sign-text"
          size="is-medium"
          class="media-left"
          type="is-grid-5">
        </b-icon>
        <div class="media-content is-size-10px has-text-default">
          <label class="has-text-default">
            Catégorie
          </label>
          <p class="is-size-14px has-text-weight-bold has-text-grid-1 mt-4">
            {{data.categorie.libelle}}
          </p>
        </div>
      </div>
    </div>
    <div
      v-if="data.regie"
      class="column is-paddingless is-6 mb-20">
      <div class="media">
        <b-icon
          icon="sign-text"
          size="is-medium"
          class="media-left"
          type="is-grid-5">
        </b-icon>
        <div class="media-content is-size-10px has-text-default">
            <label class="has-text-default">
              Régie
            </label>
          <p class="is-size-14px has-text-grid-1 mt-4 has-text-weight-bold">
            {{data.regie}}
          </p>
        </div>
      </div>
    </div>

    <div class="column is-12 is-paddingless is-hidden-desktop" v-if="data.commentaire">
      <p class="is-size-6 is-size-7-touch has-text-grid-1 has-text-weight-bold">Argumentaire :</p>
      <p class="is-size-14px has-text-grid-1 pre-line-text">{{data.commentaire}}</p>
    </div>

  </div>
</template>

<script>
export default {
  props: {
    data: Object,
  },
}
</script>

<style>

</style>
